import styled from 'styled-components';
import { GYPSUM, PANTERA } from 'HubStyleTokens/colors';
const ReducedCardWrapper = styled.div.withConfig({
  displayName: "ReducedCardWrapper",
  componentId: "sc-1hykstk-0"
})(["display:flex;align-items:center;padding:4px;margin:-4px;border-radius:3px;cursor:pointer;transition:background-color 200ms;&:hover{background-color:", ";}"], props => props.use === 'on-light' ? GYPSUM : PANTERA);
export default ReducedCardWrapper;